import { usePlexRoute } from '../../details/usePlexRoute';

export type PlexFeedTab = 'feed' | 'base' | 'timeline' | 'tasks' | 'notifications';
type Value = PlexFeedTab | null;
type Setter = (v: Value) => void;

export function useSelectedFeedTab(): [Value, Setter] {
  const [plexRoute, updatePlexRoute] = usePlexRoute();

  const selectedPlexFeedTab = ((): PlexFeedTab | null => {
    switch (plexRoute.page) {
      case 'search':
        return null;
      default:
        return plexRoute.page;
    }
  })();

  const setSelectedPlexFeedTab = (selectedPlexFeedTab: Value): void => {
    updatePlexRoute({ page: selectedPlexFeedTab || undefined });
  };

  return [selectedPlexFeedTab, setSelectedPlexFeedTab];
}
